// OWNER: AREA-EVENTS
// Section layout: supplies the "Messages" breadcrumb for every page under /messages.
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/messages')({
  staticData: { crumb: 'Messages' },
  component: Outlet,
})
